module.exports = __webpack_public_path__ + "components/panel/static/affiliate_snow-forecast-12day-premium@2-4b5e5b56b0d5a8d18a744117797f15d2.png";